export default __webpack_public_path__ + "static/media/15.4104bbb7.png";